var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14454 82.6308C0.721022 82.6308 -1.22897 79.4176 0.807475 75.4912L38.2921 3.31492C40.3309 -0.611485 43.6666 -0.611485 45.7054 3.31492L83.19 75.4936C85.2313 79.4176 83.2789 82.6308 78.8554 82.6308H5.14454Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1953 68.1096C36.1953 64.9085 38.8009 62.3029 42.0045 62.3029C45.2056 62.3029 47.8112 64.9085 47.8112 68.1096C47.8112 71.3132 45.2032 73.9188 42.0045 73.9188C38.8009 73.9188 36.1953 71.3132 36.1953 68.1096ZM36.642 24.1795C36.642 21.0528 38.9498 19.1172 42.0021 19.1172C44.9823 19.1172 47.3646 21.1272 47.3646 24.1795V52.8483C47.3646 55.9006 44.9823 57.9106 42.0021 57.9106C38.9498 57.9106 36.642 55.9726 36.642 52.8483V24.1795Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuation);
export default __webpack_public_path__ + "static/media/Cuation.b2d9fe986aa751c595f42c922a79ab93.svg";
export { ForwardRef as ReactComponent };